'use client';

import dynamic from 'next/dynamic';
import { ThemeProvider } from 'styled-components';
import MainLayout from '@/srp/MainLayout';
import StickySearchProvider from '~/context/srp/StickySearchProvider';
import type { SeoProps } from '~/server-props/srp/contracts';
import theme from '~/theme';

const QualiSurvey = dynamic(
  () => import(/* webpackChunkName: "QualiSurvey" */ '@/srp/QualiSurvey'),
  { ssr: false }
);

type OwnProps = {
  initialSeoProps?: SeoProps;
};

export default function SearchContainer({ initialSeoProps }: OwnProps) {
  return (
    <ThemeProvider theme={theme}>
      <a
        href="#srp-main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:p-md focus:bg-background-default focus:text-text-strong focus:t-body-sm"
        data-adobe-id="skip-to-main-content"
        data-analytics-id="Skip - Skip to Main Content"
        data-testid="skip-to-main-content"
      >
        Skip to main content
      </a>
      <StickySearchProvider>
        <MainLayout initialSeoProps={initialSeoProps} />
      </StickySearchProvider>
      <QualiSurvey />
    </ThemeProvider>
  );
}
